export default __webpack_public_path__ + "static/29113-da573a1081a557e305cc2ffc637a49cd.jpg";